import React, { useContext, useEffect, useMemo } from "react";
import { Col, FormCheck, Row } from "react-bootstrap";
import TextField from "../../../../component/TextField";
import { formatDateToDDMMYYYY } from "../../../../utils/FormatUtils";
import "./QuanLyHopDong.scss";
import { AppContext } from "../../../../appContext/AppContext";
import { CODE } from "../../../../utils/Constant";
import { getDetailFormGenerate } from "../../../services/KhamDoanHopDongServices"
import { QuanLyHopDongContext, QuanLyHopDongContextProps } from "../../tab-quan-ly-hop-dong/QuanLyHopDong"
import { valueStatus } from "../../../constants/PhanHeKhamDoan";
import { getFieldPermissions } from "../../../../utils/AppFunction";
import wfAxiosGenerator from "../../../../workflows/utils/WfAxiosGenerator";
import { localStorageItem } from "../../../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../../../auth/core/_consts";

type Props = {
  setValues: any;
  values: any;
  setFieldValue: any;
  currentWf?: any
  componentName?: string
};
const BASE_ENDPOINT = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_API_URL || "";

const FormKetLuan = ({ setValues, setFieldValue, values, currentWf, componentName }: Props) => {
  const { setIsLoading } = useContext(AppContext);
  const { TTNhanVien } = useContext<QuanLyHopDongContextProps>(QuanLyHopDongContext)
  const model = useMemo(() => {
    return wfAxiosGenerator(BASE_ENDPOINT, currentWf.additionalConfiguration)?.models?.find?.((item: any) => item?.componentName === componentName)
  }, [currentWf])
  useEffect(() => {
    (values?.visitId || TTNhanVien?.visitId) && detailKhamBenh(values)
  }, [TTNhanVien?.visitId])
  const detailKhamBenh = async (values: any) => {
    try {
      setIsLoading(true);
      let { data } = await getDetailFormGenerate(values?.visitId || TTNhanVien?.visitId);
      
      if (CODE.SUCCESS === data?.code) {
        setValues(data?.data)
        setIsLoading(false);
      } else {
        setValues({})
      }
    } catch (error) {
      setValues({})
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fieldPermissions = useMemo(() => getFieldPermissions(model), [model]);
  return (
    <>

      <div className="spaces w-100 form-ket-luan justify-content-center pl-10 pt-5 ">
        <Row>
          <Col xs="4">
            <div className="spaces mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">Ngày bắt đầu:</span>
              <span className="spaces fw-4 text-truncate">
                {formatDateToDDMMYYYY(TTNhanVien?.dateStarted || "")}
              </span>
            </div>
          </Col>
          <Col xs="4">
            <div className="spaces mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">Ngày kết thúc:</span>
              <span className="spaces fw-4 text-truncate">
                {values?.examEndDate || ""}
              </span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <div className="spaces mb-8 d-flex">
              <span className="d-inline-block spaces min-w-120 fw-bold">Trạng thái khám:</span>
              <span className="spaces fw-4 text-truncate">{currentWf?.name}</span>
            </div>
          </Col>
        </Row>
        {/* Xếp loại */}
        {fieldPermissions.examClassification && (
          <Row>
            <Col xs="4" className="spaces mt-10">
              <TextField
                label="Xếp loại"
                name="examClassification"
                labelClassName="min-w-100px"
                className=""
                value={values?.examClassification || ""}
                disabled={fieldPermissions.examClassification === "r"}
              />
            </Col>
          </Row>
        )}

        {/* Kết luận */}
        {fieldPermissions.examConclusion && (
          <div className="spaces w-100 justify-content-center mt-20 pl-0">
            <TextField
              name="examConclusion"
              className="text-field-label-down-line-hd min-height-100px ml-0"
              as="textarea"
              value={values?.examConclusion || ""}
              label="Kết luận"
              disabled={fieldPermissions.examConclusion === "r"}
            />
          </div>
        )}

        {/* Những vấn đề cần giải quyết */}
        {fieldPermissions.neededSolve && (
          <div className="spaces w-100 justify-content-center mt-10">
            <TextField
              name="neededSolve"
              className="text-field-label-down-line-hd min-height-200px ml-0"
              as="textarea"
              label="Những vấn đề cần giải quyết"
              value={values?.neededSolve || ""}
              disabled={fieldPermissions.neededSolve === "r"}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default FormKetLuan;
